import { EventEmitter, NgZone, Injectable } from '@angular/core';

import { Orientation } from '../../../../../kendo/kendo-angular-layout/common/orientation';

import { TiSplitterPaneComponent } from './ti.splitter-pane.component';
import { SplitterService } from '../../../../../kendo/kendo-angular-layout/splitter/splitter.service';

const SIZING_DOC_LINK = 'https://www.telerik.com/kendo-angular-ui/components/layout/splitter/panes/#toc-size';

/**
 * @hidden
 */
export interface SplitterParameters {
  containerSize: () => number;
  panes: TiSplitterPaneComponent[];
  orientation: Orientation;
}

/**
 * @hidden
 */
export interface SplitterDragState {
  index: number;
  initial: number;
  min: number;
  max: number;
}

@Injectable()
export class TiSplitterService extends SplitterService {
  public panes: TiSplitterPaneComponent[];

  constructor(public zoneValue: NgZone) {
    super(zoneValue);
  }

  public fixStaticPanes() {
    let staticPane: TiSplitterPaneComponent = null;
    let expandedPanesCount = 0;
    let staticPanesCount = 0;
    let lastIndex = -1;
    let areNeighbours = true;
    let expandedStaticPaneIndexes = [];
    this.panes.forEach((pane, index) => {
      pane.removeGrowSpaceClass();
      if (!pane.collapsed) {
        expandedPanesCount++;
        if (pane.staticPaneClass) {
          staticPanesCount++;
          staticPane = pane;
          if (lastIndex !== -1 && index - lastIndex > 1) {
            areNeighbours = false;
          }
          expandedStaticPaneIndexes.push(index);
          lastIndex = index;
        }
      }
    });
    if (staticPane) {
      if (expandedPanesCount === 1 && staticPanesCount === 1) {
        staticPane.addGrowSpaceClass();
        return true;
      }
      if (expandedPanesCount > 1 && staticPanesCount === expandedPanesCount && areNeighbours) {
        expandedStaticPaneIndexes.pop();
        let removeStatic = false;
        while (expandedStaticPaneIndexes.length) {
          let currentIndex = expandedStaticPaneIndexes.pop();
          let currentPane = this.panes[currentIndex];
          removeStatic = !removeStatic;
          if (removeStatic) {
            currentPane.clearStaticState();
          }
        }
      }
    }
  }

  public pane(index: number): TiSplitterPaneComponent {
    if (!this.panes) {
      throw new Error('Panes not initialized');
    }

    if (index < 0 || index >= this.panes.length) {
      throw new Error('Index out of range');
    }

    return this.panes[index];
  }

  public tryToggle(paneIndex: number, newValue?: boolean): boolean {
    const pane = this.pane(paneIndex);

    if (pane.collapsible) {
      pane.collapsed = newValue == null ? !pane.collapsed : newValue;
      pane.collapsedChange.emit(pane.collapsed);
      this.emitZone(this.layoutChange, {});
    }
    return pane.collapsible;
  }

  protected emitZone(emitter: EventEmitter<any>, args?: any): void {
    if (emitter.observers.length) {
      this.zoneValue.run(() => emitter.emit(args));
    }
  }
}
